import { ButtonLink, TypographyV2 } from '@which/seatbelt'

import type { Category } from '../Configs/categories'
import { pageContent } from '../Configs/pageContent'
import { CategoryToArticles } from '../Configs/suggestedArticles'
import { useLaptopHelperItemSpec } from '../hooks/useLaptopHelperItemSpec'
import styles from './ResultsScreen.module.scss'

interface NoResultsProps {
  categorySlug: Category
}

export const NoResults = ({ categorySlug }: NoResultsProps) => {
  const itemSpec = useLaptopHelperItemSpec()
  const articles = CategoryToArticles[categorySlug] ?? []
  const { content = [] } = pageContent[categorySlug]?.noResults ?? {}

  return (
    <div className={styles.noResults}>
      {content.map((paragraph, index) => (
        <TypographyV2
          key={index}
          className={styles.paragraph}
          tag="p"
          textStyle="sb-text-interface-body-default-regular"
        >
          {paragraph}
        </TypographyV2>
      ))}

      {articles.map((article, index) => (
        <ButtonLink
          key={index}
          className={styles.noResultsArticleButton}
          appearance="secondary"
          href={article.url}
          target="_blank"
          rel="nofollow noopener noreferrer"
          data-action-group="onward journey"
          data-item-text={article.title}
          data-item-parent-text="Our recommendation"
          data-item-index={index + 1}
          data-item-group="personalisation tools"
          data-tool-name="Laptop picker helper"
          data-item-spec={itemSpec}
          data-which-id="personalisation-tool-onward-journey"
          data-item-personalisation="true"
        >
          {article.title}
        </ButtonLink>
      ))}
    </div>
  )
}
